import { Injectable, Signal } from '@angular/core';
import { Query } from '@datorama/akita';
import { OtpStore, OtpState } from './otp.store';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OtpQuery extends Query<OtpState> {
  email$!: Observable<string | null>;
  otpVerified$!: Observable<boolean>;
  loading$!: Observable<boolean>;
  error$!: Observable<string | null>;
  expiresInMinutes$!: Observable<number>;

  email!: Signal<string | null>;
  otpVerified!: Signal<boolean>;
  loading!: Signal<boolean>;
  error!: Signal<string | null>;
  expiresInMinutes!: Signal<number>;

  constructor(protected override store: OtpStore) {
    super(store);

    this.email$ = this.select(state => state.email);
    this.otpVerified$ = this.select(state => state.otpVerified);
    this.loading$ = this.select(state => state.loading);
    this.error$ = this.select(state => state.error);
    this.expiresInMinutes$ = this.select(state => state.expiresInMinutes);

    this.email = toSignal(this.email$, { initialValue: null });
    this.otpVerified = toSignal(this.otpVerified$, { initialValue: false });
    this.loading = toSignal(this.loading$, { initialValue: false });
    this.error = toSignal(this.error$, { initialValue: null });
    this.expiresInMinutes = toSignal(this.expiresInMinutes$, { initialValue: 0 });
  }
}
